<template>
    <div class="main">
        <div class="top"><i class="iconfont icon-error" @click="close" ref="omg"></i></div>
        <van-cell-group class="tip">
            <van-cell title="项目名称：" v-model="ITEM_NAME" />
            <!-- <van-cell title="价格：" v-model="PRICE" /> -->
            <van-cell title="临床意义：" v-model="MEANING" />
        </van-cell-group>
        <div class="btn" v-show="ENABLED">
            <button type="button" @click="cancle">取 消</button>
            <button type="button" class="ok" @click="ok">选 择</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ITEM_NAME: String,
            PRICE: Number,
            MEANING: String,
            STATUS: Boolean,
            ENABLED: Boolean,
            // cancle:Function,
            // ok:Function
            SEL_INDEX: Number
        },
        methods: {
            cancle() {
                this.$emit('operate', false);
            },
            ok() {
                this.$emit('operate', true);
            },
            close() {
                this.$emit('close');
            }
        },
        created(){
            this.$emit('sel', this.SEL_INDEX)
        }
        // mounted() {
        //     this.$nextTick(() => {
        //         this.$refs.omg.focus();
        //     })
        // },
        // directives: {
        //     focus: {
        //         inserted: function(el) {
        //             el.focus()
        //         }
        //     }
        // }
    }
</script>

<style scoped lang="less">
    .top {
        text-align: right;
        .iconfont {
            border: 1px solid #aacd06;
            border-radius: 5px;
            font-size: 0.8rem;
            padding: 0.2rem;
            color: #fff;
            background-color: #aacd06;
            font-weight: bold;
        }
    }
    .btn {
        text-align: center;
        letter-spacing: 0.5rem;
        padding: 0.6em 0;
        height: 2rem;
        line-height: 2rem;
        button {
            background: #fff;
            color: #99C51D;
            border: 1px solid #99C51D;
            border-radius: 10px;
            font-size: 14px;
            width: 5rem;
            text-align: center;
        }
        button.ok {
            background: #99C51D;
            color: #fff;
            border: 1px solid #99C51D;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/itemInfo.vue